module.exports = __webpack_public_path__ + "static/img/ewm3.20cdd76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ewm3.jpg
// module id = NxmY
// module chunks = 1